"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Raven = _interopRequireDefault(require("Raven"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _getTimezoneGroups = _interopRequireDefault(require("timezone-utils/utils/getTimezoneGroups"));

var _getTimezoneOptions3 = _interopRequireDefault(require("MeetingsLib/utils/getTimezoneOptions"));

var _color = require("MeetingsBase/utils/color");

var _timezone = require("MeetingsLib/constants/timezone");

var TimezoneSelect = (0, _createReactClass.default)({
  displayName: "TimezoneSelect",
  propTypes: {
    userTimezone: _propTypes.default.string.isRequired,
    setTimezone: _propTypes.default.func.isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    activeLocale: _propTypes.default.string,
    dispatch: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      open: false,
      options: null,
      optionsMap: null,
      parsedUserTimezone: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var userTimezone = this.props.userTimezone;
    setTimeout(function () {
      var _getTimezoneOptions = (0, _getTimezoneOptions3.default)(),
          options = _getTimezoneOptions.options,
          optionsMap = _getTimezoneOptions.optionsMap;

      var parsedUserTimezone = _timezone.INVALID_TZ_GUESS;

      try {
        parsedUserTimezone = (0, _getTimezoneGroups.default)().resolve(userTimezone);
      } catch (error) {
        _Raven.default.captureMessage("Invalid timezone was given by `moment.tz.guess()`", {
          extra: {
            userTimezone: userTimezone,
            error: error
          }
        });
      }

      _this.setState({
        options: options,
        optionsMap: optionsMap,
        parsedUserTimezone: parsedUserTimezone
      });
    }, 0);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        currentActiveLocale = _this$props.activeLocale,
        currentUserTimezone = _this$props.userTimezone;
    var nextActiveLocale = nextProps.activeLocale,
        nextUserTimezone = nextProps.userTimezone;

    if (currentActiveLocale !== nextActiveLocale) {
      var _getTimezoneOptions2 = (0, _getTimezoneOptions3.default)(),
          options = _getTimezoneOptions2.options,
          optionsMap = _getTimezoneOptions2.optionsMap;

      this.setState({
        options: options,
        optionsMap: optionsMap
      });
    }

    if (currentUserTimezone !== nextUserTimezone) {
      this.setState({
        parsedUserTimezone: (0, _getTimezoneGroups.default)().resolve(nextUserTimezone)
      });
    }
  },
  onTimezoneChange: function onTimezoneChange(_ref) {
    var value = _ref.target.value;
    var setTimezone = this.props.setTimezone;
    setTimezone(value);
    this.setState({
      open: false
    });
  },
  getDropdownStyle: function getDropdownStyle() {
    var primaryColor = this.props.branding.primaryColor;
    var colorToUse = (0, _color.getPrimaryColorOrDefault)(primaryColor);
    return {
      color: colorToUse,
      display: 'inline-grid'
    };
  },
  renderDropdownText: function renderDropdownText() {
    var _this$state = this.state,
        optionsMap = _this$state.optionsMap,
        parsedUserTimezone = _this$state.parsedUserTimezone;
    return optionsMap[parsedUserTimezone] || parsedUserTimezone;
  },
  render: function render() {
    var _this2 = this;

    var options = this.state.options;

    if (options === null) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        layout: "centered"
      });
    }

    var _this$props2 = this.props,
        __userTimezone = _this$props2.userTimezone,
        __setTimezone = _this$props2.setTimezone,
        __branding = _this$props2.branding,
        __activeLocale = _this$props2.activeLocale,
        __dispatch = _this$props2.dispatch,
        dropdownProps = (0, _objectWithoutProperties2.default)(_this$props2, ["userTimezone", "setTimezone", "branding", "activeLocale", "dispatch"]);
    return _react.default.createElement(_UIDropdown.default, Object.assign({
      open: this.state.open,
      onOpenChange: function onOpenChange(_ref2) {
        var value = _ref2.target.value;
        return _this2.setState({
          open: value
        });
      },
      buttonClassName: "timezone-select m-bottom-4",
      menuWidth: 275,
      buttonUse: "link",
      buttonText: this.renderDropdownText(),
      placement: "bottom",
      style: this.getDropdownStyle()
    }, dropdownProps), _react.default.createElement(_UITypeahead.default, {
      searchClassName: "timezone-select-search",
      options: this.state.options,
      onChange: this.onTimezoneChange
    }));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    activeLocale: state.activeLocale
  };
})(TimezoneSelect);

exports.default = _default;
module.exports = exports.default;